import { Component } from 'react';

export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('The Record Base page failed to render:', error, errorInfo);
  }

  render() {
    if (!this.state.error) return this.props.children;

    const isAdminHost = typeof window !== 'undefined'
      && window.location.hostname.toLowerCase().startsWith('admin.');
    const safeHome = isAdminHost ? '/admin/staff-menu' : '/';

    return (
      <main className="flex min-h-screen items-center justify-center bg-[#050609] px-6 text-white">
        <section className="w-full max-w-xl rounded-2xl border border-white/10 bg-white/[0.04] p-8 text-center shadow-2xl shadow-black/40">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#66a8ff]">Page recovery</p>
          <h1 className="mt-3 font-unbounded text-2xl font-bold">This page could not finish loading.</h1>
          <p className="mt-3 text-sm leading-6 text-white/60">
            An action may have finished before the display failed. Check its current status before retrying, then reload this page or return to a safe starting point.
          </p>
          <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-md bg-[#0070f3] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#328bf6]"
            >
              Reload page
            </button>
            <button
              type="button"
              onClick={() => window.location.assign(safeHome)}
              className="rounded-md border border-white/10 bg-white/[0.04] px-5 py-3 text-sm font-semibold text-white transition hover:bg-white/[0.08]"
            >
              Return to safety
            </button>
          </div>
        </section>
      </main>
    );
  }
}
